import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=4b093e14&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=ts"
export * from "./Coupon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b093e14",
  null
  
)

export default component.exports